class Role {
  constructor(Role) {
    this.Role = Role;
  }

  isMainInsured() {
    return this.Role === 'H';
  }

  isCoInsured() {
    return this.Role === 'M';
  }

  isPartnerInsured() {
    return this.Role === 'P';
  }
}
export { Role as default };
